export default function chinhSachThanhToan() {
  return (
    <div className="container chinh-sach mt-6">
      <div className="chinh-sach-hoan-tien list-chinhsach px-4">
        <h4 className="text-center text-uppercase">
          Chính sách thanh toán, hoàn tiền
        </h4>
        <blockquote className="mb-3">
          <p>1. Hình thức thanh toán</p>
        </blockquote>
        <strong>a. Thanh toán chuyển khoản</strong>
        <p className="mb-2"></p>
        <p>
          Nếu bạn đã từng mua hàng tại website gigadigital.vn và tin tưởng vào
          dịch vụ của chúng tôi thì bạn có thể lựa chọn phương án thanh toán
          bằng chuyển khoản để đạt hiệu quả cao nhất về chi phí và thời gian
          trong thanh toán. Thông tin tài khoản sẽ được hướng dẫn cụ thể khi bạn
          hoàn thành hóa đơn.
        </p>
        <br />
        <strong>Thông tin chuyển khoản:</strong>

        <ul className="list-unstyled">
          <li>Ngân hàng: Ngân hàng TMCP Quân Đội</li>
          <li>Chủ tài khoản: CÔNG TY CỔ PHẦN CÔNG NGHỆ HỢP LONG</li>
          <li>STK: 6622336688</li>
          <li>Chi nhánh: Chi nhánh Trần Duy Hưng</li>
        </ul>
        <br />
        <strong>b. Nhận hàng trả tiền</strong>
        <ul className="list-unstyled">
          <li>
            - Bạn có thể lựa chọn phương án thanh toán này đối với một số trường
            hợp hạn chế do Giga Digital quyết định. Với một số trường hợp khác,
            chúng tôi sẽ từ chối chấp nhận phương thức thanh toán này.
          </li>
          <li>
            - Khách hàng sử dụng gói dịch vụ vận chuyển COD sẽ áp dụng thanh
            toán ngay khi nhận hàng bằng tiền mặt.
          </li>
          <li>
            - Trong trường hợp sản phẩm được chấp thuận, bạn có thể vẫn phải
            thanh toán trước 30% giá trị đơn hàng, số tiền còn lại sẽ được thanh
            toán khi nhân viên giao hàng đến giao hàng cho bạn.{" "}
          </li>
          <li>
            Chú ý: Trong thời gian 7 ngày kể từ ngày lập hóa đơn nếu bạn không
            thực hiện việc thanh toán/ đặt cọc thì chúng tôi sẽ hủy hóa đơn mà
            không cần báo trước.
          </li>
        </ul>
        <br />
        <blockquote className="mb-3">
          <p>2. Hoàn tiền</p>
        </blockquote>
        <p className="mb-2"></p>
        <ul className="list-unstyled">
          <li>
            - Thời hạn hoàn trả: Giga Digital sẽ chỉ hoàn tiền cho Khách hàng
            khi Giga Digital xác nhận đã nhận được Hàng trả lại và không có nhu
            cầu đổi hàng với giá trị tương đương.
          </li>
          <li>
            - Cách thức lấy lại tiền: Tùy từng trường hợp, tiền hoàn trả sẽ được
            chuyển vào thẻ tín dụng/tài khoản ngân hàng được chỉ định của Người
            mua hoặc bằng phương thức do thỏa thuận của 02 bên.
          </li>
          <li>
            - Chi phí cho việc hoàn trả: Nếu sản phẩm được xác thực không thuộc
            lỗi của Giga Digital thì người mua phải chịu vận chuyển đối với hàng
            trả lại.
          </li>
          <li>
            Để biết thêm thông tin chi tiết, quý khách vui lòng liên hệ Bộ phận
            chăm sóc khách hàng Giga Digital để được trợ giúp. Xin cảm ơn!
          </li>
        </ul>
      </div>
    </div>
  );
}
